import ML from '../assets/images/ML.svg';
import BD from '../assets/images/BD.svg';
import AD from '../assets/images/AD.svg';
import WD from '../assets/images/WD.svg';
import CP from '../assets/images/CP.svg';
import DSGN from '../assets/images/DSGN.svg';
export const Domain=[
    {
        id: 1,
        image: BD,
        name: "Big Data",
        content: "Big data is a term used to describe large and complex datasets that cannot be handled by traditional data processing applications. It is the collection of massive amounts of structured and unstructured data from different sources that can be used to identify patterns, trends and correlations to help companies make better decisions and gain a competitive advantage.",
        
    },
    {
        id: 2,
        image: ML,
        name: "Machine Learning",
        content: "Machine learning is the process of using algorithms to enable systems to learn and improve from experience without being explicitly programmed. It is a subset of artificial intelligence that focuses on computer algorithms to learn from data, identify patterns, and make decisions. It is a powerful tool for businesses as it can help to make accurate predictions and increase efficiency by automating multiple tasks.",
    },
    {
        id: 3,
        image: CP,
        name: "Competitive Coding",
        content: "Competitive programming is a mind sport where participants attempt to write programs to solve a given problem faster and more accurately than others. Competitive programming is a great way to hone programming and problem solving skills, as well as to learn about algorithms and data structures. Additionally, it is a great way to practice coding and develop logical thinking skills.",
    },
    {
        id: 4,
        image: AD,
        name: "App Development",
        content: "App development is an emerging field due to the ever increasing popularity of mobile devices and the demand for more powerful and feature rich applications. It requires a deep understanding of the mobile platform, user interface design, and the capabilities of the device. App development is a rewarding and challenging career, and those with the right skillset have the potential to create highly successful and popular apps.",
    },
    {
        id: 5,
        image: WD,
        name: "Web Development",
        content: "Web development is the process of building, creating, and maintaining websites. It involves web design, web content development, client & server-side scripting, and network security configuration including use of multiple technologies. Web Development is an ever-evolving and an important skill that can lead to a successful career in the tech industry.",
    },
    {
        id: 6,
        image: DSGN,
        name: "UI/UX Designing",
        content: "UI/UX design involves understanding the needs and goals of users and then designing visually pleasing and functional interfaces. UI/UX design is an important part of software development, as it allows for user feedback and testing that can be used to refine the design. It is a highly iterative process that focuses on creating an engaging and intuitive experience for users.",
    },
]